import React, { useState } from 'react';
import {
  Box,
  Button
} from '@material-ui/core';

import VendorsTable from 'components/Vendors/VendorsTable';
import VendorDetails from 'components/Vendors/VendorDetails';

const VendorListResults = (props) => {
  
  const [open, setOpen] = useState(false);
  const [update, setUpdate] = useState(false);
  const [updateInfo, setUpdateInfo] = useState({});

  const addVendor = () => {
    setOpen(true);
    setUpdate(false);
    setUpdateInfo({});
  };

  const updateVendor = () => {
    setOpen(true);
    setUpdate(true);
  };

  const cancelAddUpdate = () => {
    setOpen(false);
    setUpdate(false);
    setUpdateInfo({});
  };

  const createVendorDisplayId = () => {
    const length = props.idGen.find(idGen => idGen.info.user === props.activeUserId).body.vendor;
    let vendorNum;
    length < 100 ? 
      vendorNum = new Array(3 + 1 - (length + '').length).join('0') + length
    : vendorNum = length
    return("VEN-" + vendorNum);
  };

  return (
    <Box>
      { open ?
        ( update ?
          <VendorDetails
            update={update}
            cancelAddUpdate={cancelAddUpdate}
            vendorInfo={updateInfo}
          /> :
          <VendorDetails
            activeUserId={props.activeUserId}
            update={update}
            cancelAddUpdate={cancelAddUpdate}
            vendorInfo={{
              displayId: createVendorDisplayId(),
              name: "",
              phone: "",
              department: "Kaccha",
              joiningDate: ""
            }}
          />
        ) :
        <Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            <Button
              color="primary"
              variant="contained"
              onClick={addVendor}
            >
              Add Vendor
            </Button>
          </Box>
          <Box marginTop={2}>
            <VendorsTable
              vendors={props.vendors}
              expenses={props.expenses}
              products={props.products}
              processes={props.processes}
              user={props.user}
              updateVendor={updateVendor}
              setUpdateInfo={setUpdateInfo}
            />
          </Box>
        </Box>
      }
    </Box>
  )
};

export default VendorListResults;